// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + ({"279":"component---src-pages-index-jsx","415":"component---src-pages-404-jsx"}[chunkId] || chunkId) + "-" + {"279":"4c56390282c29eb8a484","415":"49dd706e3ed71451d09c","454":"677a2e7c7cc7b381f8d2"}[chunkId] + ".js";
};